import { ReactNode } from "react";
import { Tooltip, TooltipContent, TooltipTrigger } from "~/components/ui/tooltip";
import { cn } from "~/lib/utils";

interface SectionNavPlaceholderProps {
  icon: ReactNode;
  label: string;
  // Extra classes (default padding is `px-3 py-2` when omitted).
  className?: string;
}

/**
 * A section sidebar row for a feature that belongs in the information
 * architecture but does not exist yet. Deliberately not a link and not a
 * button: there is nowhere to go and nothing to press.
 */
export const SectionNavPlaceholder = ({
  icon,
  label,
  className = "px-3 py-2",
}: SectionNavPlaceholderProps) => (
  <Tooltip>
    <TooltipTrigger asChild>
      <span
        aria-disabled="true"
        className={cn(
          "flex cursor-default items-center gap-2.5 rounded-md text-sm font-medium text-muted-foreground/40",
          className
        )}
      >
        <span className="shrink-0">{icon}</span>
        {label}
      </span>
    </TooltipTrigger>
    <TooltipContent side="right">Coming soon</TooltipContent>
  </Tooltip>
);
